import { render, staticRenderFns } from "./Ddts.vue?vue&type=template&id=7c618713"
import script from "./Ddts.vue?vue&type=script&lang=js"
export * from "./Ddts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports